import Grid from '../Grid';
import Row from '../Row';
import Text from '../Text';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
export var Wrapper = withTheme(styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-2idj7f-0"
})(["", ""], function (_ref) {
  var mobileImage = _ref.mobileImage,
      desktopImage = _ref.desktopImage,
      coreTheme = _ref.coreTheme;
  return css(["background-repeat:no-repeat;background-position:center center;background-size:cover;background-image:", ";@media (min-width:", "){background-image:", ";}"], "url('".concat(mobileImage || desktopImage, "')"), coreTheme.brk_xs, "url('".concat(desktopImage, "')"));
}));
export var StyledGrid = styled(Grid).withConfig({
  displayName: "style__StyledGrid",
  componentId: "sc-2idj7f-1"
})(["&&{padding:0;width:100%;}"]);
export var StyledRow = withTheme(styled(Row).withConfig({
  displayName: "style__StyledRow",
  componentId: "sc-2idj7f-2"
})(["", ""], function (_ref2) {
  var reverse = _ref2.reverse,
      coreTheme = _ref2.coreTheme;
  return css(["flex-direction:", ";@media (min-width:", "){flex-direction:", ";}"], reverse ? "column-reverse" : 'column', coreTheme.brk_xs, reverse ? "row-reverse" : 'row');
}));
export var StyledEmptyContentContainer = withTheme(styled.div.withConfig({
  displayName: "style__StyledEmptyContentContainer",
  componentId: "sc-2idj7f-3"
})(["", ""], function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return css(["height:300px;@media (min-width:", "){width:100%;height:480px;}"], coreTheme.brk_xs);
}));
export var StyledTextContainer = withTheme(styled.div.withConfig({
  displayName: "style__StyledTextContainer",
  componentId: "sc-2idj7f-4"
})(["", ""], function (_ref4) {
  var coreTheme = _ref4.coreTheme;
  return css(["display:flex;flex-direction:column;justify-content:center;padding:", "px ", "px;min-height:260px;align-items:center;@media (min-width:", "){padding:0 50px;height:480px;align-items:flex-start;}@media (min-width:", "){padding:0 80px;}@media (min-width:", "){padding:0 95px;}svg{width:48px;height:48px;@media (min-width:", "){width:60px;height:60px;}@media (min-width:", "){width:72px;height:72px;}}"], coreTheme.space_5, coreTheme.space_6, coreTheme.brk_xs, coreTheme.brk_sm, coreTheme.brk_md, coreTheme.brk_xs, coreTheme.brk_md);
}));
export var StyledIconImage = withTheme(styled.img.withConfig({
  displayName: "style__StyledIconImage",
  componentId: "sc-2idj7f-5"
})(["", ""], function (_ref5) {
  var coreTheme = _ref5.coreTheme;
  return css(["width:48px;height:48px;@media (min-width:", "){width:60px;height:60px;}@media (min-width:", "){width:72px;height:72px;}"], coreTheme.brk_xs, coreTheme.brk_md);
}));
export var StyledHeaderText = withTheme(styled(Text).withConfig({
  displayName: "style__StyledHeaderText",
  componentId: "sc-2idj7f-6"
})(["", ""], function (_ref6) {
  var coreTheme = _ref6.coreTheme;
  return css(["text-align:center;@media (min-width:", "){text-align:left;}"], coreTheme.brk_xs);
}));
export var StyledBodyText = withTheme(styled(Text).withConfig({
  displayName: "style__StyledBodyText",
  componentId: "sc-2idj7f-7"
})(["", ""], function (_ref7) {
  var coreTheme = _ref7.coreTheme;
  return css(["padding-top:", "px;text-align:center;@media (min-width:", "){padding-top:", "px;text-align:left;}"], coreTheme.space_3, coreTheme.brk_xs, coreTheme.space_4);
}));